import ApiClient from './ApiClient';

class DataDeletionRequestsAPI extends ApiClient {
  constructor() {
    super('data_deletion_requests', { accountScoped: true });
  }
}

export default new DataDeletionRequestsAPI();
